module.exports = __webpack_public_path__ + "static/media/fpsZh.47f52036.svg";